import { ProductSavedQueryBackendInterface } from './product-saved-query.backend-interface';
import { ProductSavedQuery } from './product-saved-query';


export const generateProductSavedQueryFromBackendInput = (input: ProductSavedQueryBackendInterface) => {
  const productSavedQuery: ProductSavedQuery = {
    uuid: input.Uuid
  };

  if (input.Name) {
    productSavedQuery.name = input.Name;
  }

  if (input.Category) {
    productSavedQuery.category = input.Category;
  }

  if (Array.isArray(input.Supplier)) {
    productSavedQuery.supplier = input.Supplier;
  }

  if (input.BasicFilters) {
    try {
      productSavedQuery.basicFilters = JSON.parse(input.BasicFilters);
    } catch (e) {}
  }

  return productSavedQuery;
};
